import {assertAndContinue} from 'Asserts';
import ArgType, {withErrorsAllowed} from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as util from 'notebook/tables/excess/Util';
import flatten from 'notebook/tables/excess/util/flatten';
import {EvaluablePrimitive} from 'notebook/tables/typed-values/DataTypes';

export default {
  name: 'ISERROR',
  category: FunctionCategory.LOGIC,
  shortDescription: 'Checks whether a value is an error.',
  description: 'Checks whether a value is an error.',
  params: [
    {
      name: 'value',
      type: withErrorsAllowed(ArgType.any),
      description: 'The cell or range to be verified as an error type.',
    },
  ],
  eval: (...values): EvaluablePrimitive => {
    assertAndContinue(values.length === 1, 'Expected ISERROR to receive exactly one argument', {
      numArguments: values.length,
    });
    /*
    We re-throw all circular dependencies.  Note that there are two different types of circular dependencies:
    circular dependencies that iserror causes, and external circular dependencies.  This implementation does
    not differentiate between the two due to the current method for determining cycles.
     */
    values = flatten(values);
    const circ = values.find(
      (value) => value instanceof util.ReferenceError && value.message === 'Circular dependency detected'
    );
    if (circ != null) {
      throw circ;
    }
    return values.some((x) => x instanceof util.CellError);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
